import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpButtonComponent } from './help-button/help-button.component';
import {BottomMenuComponent} from './bottom-menu/bottom-menu.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import {SnackbarModule} from 'ngx-snackbar';
import { TimerComponent } from './timer/timer.component';
import { FooterComponent } from './footer/footer.component';
import { CardListComponent } from './card-list/card-list.component';
import { OperatorListComponent } from './operator-list/operator-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DynamicPassComponent } from './dynamic-pass/dynamic-pass.component';
import {NgxMaskModule} from 'ngx-mask';
import {PassService} from './dynamic-pass/pass.service';
import { DestinationCardsComponent } from './destination-cards/destination-cards.component';
import { PriceComponent } from './price/price.component';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { ChildTopMenuComponent } from './child-top-menu/child-top-menu.component';
import { HorizontalMenuItemComponent } from './horizontal-menu-item/horizontal-menu-item.component';
import {BillTypeComponent} from './bill-type/bill-type.component';
import { OwnDepositsComponent } from './own-deposits/own-deposits.component';
import { DestinationDepositComponent } from './destination-deposit/destination-deposit.component';
import { DestinationShebaComponent } from './destination-sheba/destination-sheba.component';
import { DatePickerShamsiComponent } from './date-picker-shamsi/date-picker-shamsi.component';
import { IosLikePickerComponent } from './date-picker-shamsi/ios-like-picker/ios-like-picker.component';
import { EmptyBoxComponent } from './empty-box/empty-box.component';
import { HistoryComponentComponent } from './history-component/history-component.component';
import {PipesModule} from '@vendor/pipes/pipes.module';
import { StatementComponentComponent } from './statement-component/statement-component.component';
import { LoaderComponent } from './loader/loader.component';
import { SavedBillComponent } from './saved-bill/saved-bill.component';
import { MobileInputComponent } from './mobile-input/mobile-input.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ActionBoxComponent } from './action-box/action-box.component';
import { PayaReasonComponent } from './paya-reason/paya-reason.component';
import { VersionSliderComponent } from './version-slider/version-slider.component';
import { PollingFormComponent } from './polling-form/polling-form.component';
import {FormSectionsComponent} from './dynamicForm/form-sections/form-sections.component';
import {FormInputsComponent} from './dynamicForm/form-inputs/form-inputs.component';
import {TextFieldComponent} from './dynamicForm/text-field/text-field.component';
import { DynamicFormComponent } from './dynamicForm/dynamic-form/dynamic-form.component';
import { DisableServiceComponent } from './disable-service/disable-service.component';
import { OtpInputComponent } from './otp/otp.component';
import { OwnDepositsForCacheChequeComponent } from './own-deposits-cache-cheque/own-deposits-cache-cheque.component';
@NgModule({
  declarations: [
    HelpButtonComponent,
    BottomMenuComponent,
    SnackBarComponent,
    TimerComponent,
    FooterComponent,
    CardListComponent,
    DynamicPassComponent,
    OperatorListComponent,
    DestinationCardsComponent,
    PriceComponent,
    TopMenuComponent,
    ChildTopMenuComponent,
    HorizontalMenuItemComponent,
    BillTypeComponent,
    DatePickerShamsiComponent,
    IosLikePickerComponent,
    OwnDepositsComponent,
    OwnDepositsForCacheChequeComponent,
    DestinationDepositComponent,
    DestinationShebaComponent,
    EmptyBoxComponent,
    HistoryComponentComponent,
    StatementComponentComponent,
    LoaderComponent,
    SavedBillComponent,
    MobileInputComponent,
    ConfirmModalComponent,
    ActionBoxComponent,
    PayaReasonComponent,
    VersionSliderComponent,
    PollingFormComponent,
    FormSectionsComponent,
    FormInputsComponent,
    TextFieldComponent,
    DynamicFormComponent,
    DisableServiceComponent,
    OtpInputComponent,
  ],
  imports: [
    PipesModule,
    CommonModule,
    SnackbarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskModule.forRoot(),
    InfiniteScrollModule,
  ],
  providers: [PassService],
  exports: [
    HelpButtonComponent,
    BottomMenuComponent,
    SnackBarComponent,
    TimerComponent,
    FooterComponent,
    CardListComponent,
    DynamicPassComponent,
    OperatorListComponent,
    DestinationCardsComponent,
    PriceComponent,
    TopMenuComponent,
    ChildTopMenuComponent,
    HorizontalMenuItemComponent,
    BillTypeComponent,
    OwnDepositsComponent,
    OwnDepositsForCacheChequeComponent,
    DestinationDepositComponent,
    DestinationShebaComponent,
    DatePickerShamsiComponent,
    IosLikePickerComponent,
    EmptyBoxComponent,
    HistoryComponentComponent,
    StatementComponentComponent,
    LoaderComponent,
    SavedBillComponent,
    MobileInputComponent,
    ConfirmModalComponent,
    ActionBoxComponent,
    PayaReasonComponent,
    VersionSliderComponent,
    PollingFormComponent,
    FormSectionsComponent,
    FormInputsComponent,
    TextFieldComponent,
    DynamicFormComponent,
    DisableServiceComponent,
    OtpInputComponent,
  ],
  schemas: [
    NO_ERRORS_SCHEMA // for third party component
  ],
})
export class SharedComponentModule { }
